import { IEditor, PluginEvent, PluginEventType } from 'roosterjs-editor-types';
import { LINK_PREVIEW_ENTITY_TYPE } from 'owa-link-preview/lib/utils/constants';

export default function linkPreviewPluginTrigger(evt: PluginEvent, editor: IEditor) {
    return isPossibleLinkPreviewEvent(evt) && editor.queryElements('a').length > 0;
}

function isPossibleLinkPreviewEvent(event: PluginEvent) {
    return (
        event.eventType === PluginEventType.ContentChanged ||
        event.eventType === PluginEventType.EditorReady ||
        (event.eventType == PluginEventType.EntityOperation &&
            event.entity.type == LINK_PREVIEW_ENTITY_TYPE)
    );
}
